import React from "react"
import Button from "../common/Button.jsx"

export default function OrdersHeader({
    showBasicOrderButton = true,
    onBasicOrderClick = undefined,
    onNewOrderClick = undefined,
    actionsSlot = null,
    rightSlot = null,
}) {
    return (
        <div
            className={
                "d-flex flex-column flex-sm-row justify-content-between " +
                "align-items-start align-items-sm-center mb-4"
            }
        >
            <h1 className="fs-2 fw-bold text-dark">Orders</h1>
            <div className="d-flex gap-2 mt-3 mt-sm-0 align-items-center flex-wrap">
                {rightSlot}
                {actionsSlot}
                {showBasicOrderButton ? (
                    <Button
                        variant="outline"
                        size="sm"
                        className="v2-not-implemented-btn"
                        onClick={onBasicOrderClick}
                        title="Not implemented yet"
                    >
                        Basic Order
                    </Button>
                ) : null}
                <Button
                    variant="custom"
                    size="sm"
                    onClick={onNewOrderClick}
                >
                    <span className="d-inline d-md-none">New</span>
                    <span className="d-none d-md-inline">New Order</span>
                </Button>
            </div>
        </div>
    )
}
